<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1105133572
     */
    const props = defineProps<IWidgetProps<QuoteData>>();
    const { cmsComponentProps } = useWidget(props);
</script>

<template>
    <lazy-atm-quote
        v-if="data"
        v-bind="cmsComponentProps" />
</template>
